import Component from "@ember/component"
export default class StandardUsage extends Component {}
